import React, { useEffect, useState } from "react";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Box,
  CircularProgress,
  Stack,
  useMediaQuery,
} from "@mui/material";
import "../../../../static/styles/filterComponent.css";

function FilterComponent({ onFilterChange, filterData }) {
  const [selectedFilters, setSelectedFilters] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const isSmallScreen = useMediaQuery("(max-width:1400px)");

  const isValidFilterValue = (value) => {
    return typeof value === "string" || typeof value === "number";
  };

  useEffect(() => {
    // see if there filters stored
    const storedFilters = JSON.parse(
      sessionStorage.getItem("homeFilters") || "{}"
    );
    const validatedFilters = Object.entries(storedFilters).reduce(
      (acc, [type, value]) => {
        acc[type] = isValidFilterValue(value) ? value : "default";
        return acc;
      },
      {}
    );

    setSelectedFilters(validatedFilters);
    Object.entries(validatedFilters).forEach(([type, value]) =>
      onFilterChange(value, type)
    );
    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (!filterData || isLoading) return;
    const updatedFilters = { ...selectedFilters };
    filterData.forEach((feature) => {
      if (!isValidFilterValue(updatedFilters[feature.type])) {
        updatedFilters[feature.type] = "default";
      }
    });

    setSelectedFilters(updatedFilters);
    updateSessionStorage(updatedFilters);
  }, [filterData, isLoading]);

  const updateSessionStorage = (filters) => {
    const validFilters = Object.entries(filters).reduce(
      (acc, [type, value]) => {
        if (isValidFilterValue(value)) {
          acc[type] = value;
        }
        return acc;
      },
      {}
    );
    sessionStorage.setItem("homeFilters", JSON.stringify(validFilters));
  };

  const handleFilterChange = (value, type) => {
    if (!isValidFilterValue(value)) {
      value = "default";
    }
    const newFilters = { ...selectedFilters, [type]: value };
    setSelectedFilters(newFilters);
    updateSessionStorage(newFilters);
    onFilterChange(value, type);
  };

  return (
    <Box position="relative" display="grid" marginTop={2}>
      {isLoading || !filterData ? (
        <CircularProgress />
      ) : (
        <Stack
          direction={isSmallScreen ? "column" : "row"}
          spacing={2}
          alignItems="center"
          justifyContent="center"
        >
          {filterData.map((feature) => {
            const isActive =
              selectedFilters[feature.type] &&
              selectedFilters[feature.type] !== "default";
            return (
              <FormControl
                variant="outlined"
                sx={{
                  minWidth: "140px",
                  backgroundColor: isActive
                    ? "rgba(0, 0, 0, 0.04)"
                    : "transparent",
                  borderRadius: "4px",
                  transition: "all 0.3s ease",
                }}
                key={feature.type}
              >
                <InputLabel
                  id={`${feature.type}-${feature.key}-label`}
                  sx={{
                    transform: "translateY(-15px)",
                    fontSize: "12px",
                  }}
                >
                  {feature.type.toUpperCase()}
                </InputLabel>
                <Select
                  id={`${feature.type}${feature.key}-filter`}
                  value={selectedFilters[feature.type] || "default"}
                  onChange={(event) =>
                    handleFilterChange(event.target.value, feature.type)
                  }
                  sx={{
                    maxWidth: "140px",
                    ".MuiOutlinedInput-notchedOutline": {
                      borderColor: isActive ? "primary.main" : "inherit",
                      borderWidth: isActive ? "2px" : "1px",
                    },
                    color: isActive ? "primary.main" : "inherit",
                    fontWeight: isActive ? "bold" : "normal",
                  }}
                >
                  <MenuItem value="default">All</MenuItem>
                  {feature.data.map((item, index) => (
                    <MenuItem key={`${feature.type}${item.id}`} value={item.id}>
                      {item.identifier ||
                        item.properties?.name ||
                        item.properties?.identifier ||
                        `Item ${index + 1}`}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            );
          })}
        </Stack>
      )}
    </Box>
  );
}

export default FilterComponent;
